import React from 'react';
import './Contact.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      ),
      title: "Email",
      value: "josh@joshuawentzell.me",
      link: "mailto:josh@joshuawentzell.me"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
      ),
      title: "Location",
      value: "Pittsburgh, PA",
      link: "#"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
        </svg>
      ),
      title: "LinkedIn",
      value: "joshua-wentzell-0574b330",
      link: "https://www.linkedin.com/in/joshua-wentzell-0574b330/"
    }
  ];

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <h2 className="section-title text-center">Get In Touch</h2>
        <p className="section-subtitle text-center">
          I'm always interested in new opportunities and collaborations. 
          Let's discuss how we can work together!
        </p>
        
        <div className="contact-content-simple">
          <div className="contact-info-centered">
            <h3>Let's Connect</h3>
            <p>
              Feel free to reach out if you have any questions about enterprise automation, 
              infrastructure solutions, or potential collaboration opportunities. I'd love to 
              discuss how we can work together!
            </p>
            
            <div className="contact-methods">
              {contactInfo.map((contact, index) => (
                <a 
                  key={index}
                  href={contact.link}
                  className="contact-method"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="contact-icon">
                    {contact.icon}
                  </div>
                  <div className="contact-details">
                    <h4>{contact.title}</h4>
                    <p>{contact.value}</p>
                  </div>
                </a>
              ))}
            </div>
            
            <div className="contact-cta">
              <a 
                href="mailto:josh@joshuawentzell.me" 
                className="btn btn-primary"
              >
                Send Me an Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;